"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentDivision = /** @class */ (function () {
    function TournamentDivision() {
    }
    return TournamentDivision;
}());
exports.default = TournamentDivision;
